import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import listPlugin from "@fullcalendar/list";

document.addEventListener("DOMContentLoaded", function() {
  const calendarEl = document.getElementById("calendar");

  if (!calendarEl) return;

  const initialMobile = window.innerWidth < 768;

  const calendar = new Calendar(calendarEl, {
    // timeZone: "UTC",
    plugins: [dayGridPlugin, listPlugin],
    initialView: initialMobile ? "listMonth" : "dayGridMonth",
    events: window.location.pathname,
    height: "85vh",
    validRange: {
      start: new Date().setFullYear(new Date().getFullYear() - 2),
      end: new Date().setFullYear(new Date().getFullYear() + 10)
    },
    headerToolbar: {
      start: "title",
      // center: "dayGridMonth,listMonth",
      end: "today prev,next"
    }
  });

  calendar.render();

  window.addEventListener("resize", () => {
    const mobile = window.innerWidth < 768;
    if (mobile && calendar.view.type !== "listMonth") {
      calendar.changeView("listMonth");
    } else if (!mobile && calendar.view.type !== "dayGridMonth") {
      calendar.changeView("dayGridMonth");
    }
  });
});
